import React from 'react';
import { X, ShieldCheck } from 'lucide-react';

export default function KvkkModal({ isOpen, onClose, onAcknowledge, isMandatory = false }) {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: 'rgba(15, 23, 42, 0.65)',
      backdropFilter: 'blur(6px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 99999,
      padding: 20
    }}>
      <div style={{
        background: '#ffffff',
        borderRadius: 20,
        maxWidth: 680,
        width: '100%',
        maxHeight: '85vh',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 25px 60px rgba(0, 0, 0, 0.25)',
        overflow: 'hidden',
        animation: 'fadeIn 0.2s ease-out'
      }}>
        {/* Header */}
        <div style={{
          padding: '20px 24px',
          borderBottom: '1px solid #f1f5f9',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: '#f8fafc'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 38,
              height: 38,
              borderRadius: 10,
              background: '#e0f2fe',
              color: '#0284c7',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <ShieldCheck size={22} />
            </div>
            <div>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#0f172a' }}>
                Kişisel Verilerin Korunması ve Aydınlatma Metni
              </h3>
              <p style={{ margin: 0, fontSize: 12, color: '#64748b' }}>
                Eğitim ve Gelişim Portalı Bilgilendirmesi
              </p>
            </div>
          </div>
          {!isMandatory && (
            <button
              onClick={!isMandatory ? onClose : undefined}
              style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                color: '#94a3b8',
                padding: 6,
                borderRadius: 8,
                display: 'flex'
              }}
            >
              <X size={20} />
            </button>
          )}
        </div>

        {/* İçerik */}
        <div style={{
          padding: '24px',
          overflowY: 'auto',
          fontSize: 13.5,
          lineHeight: 1.7,
          color: '#334155',
          fontFamily: 'inherit'
        }}>
          <p style={{ marginTop: 0 }}>
            Bu aydınlatma metni, 6698 sayılı <strong>Kişisel Verilerin Korunması Kanunu (“KVKK”)</strong> ve ilgili mevzuat uyarınca; şirketimiz bünyesinde hizmet veren <strong>Eğitim & Akademi Yönetim Portalı</strong> üzerinden gerçekleştirilen kişisel veri işleme faaliyetleri hakkında çalışanlarımızı ve portal kullanıcılarımızı bilgilendirmek amacıyla hazırlanmıştır.
          </p>

          <h4 style={{ color: '#0f172a', fontSize: 14, margin: '18px 0 8px' }}>1. Veri Sorumlusu</h4>
          <p>
            Kişisel verileriniz, 6698 sayılı Kanun kapsamında veri sorumlusu sıfatıyla şirketimiz tarafından aşağıda açıklanan çerçevede işlenmektedir.
          </p>

          <h4 style={{ color: '#0f172a', fontSize: 14, margin: '18px 0 8px' }}>2. İşlenen Kişisel Veri Kategorileri</h4>
          <ul style={{ paddingLeft: 20, margin: '8px 0' }}>
            <li><strong>Kimlik ve Kurumsal Bilgiler:</strong> Ad, soyad, sicil numarası, şirket, departman, birim, unvan ve yönetici bilgisi.</li>
            <li><strong>İletişim Bilgileri:</strong> Kurumsal/kişisel e-posta adresi, telefon numarası.</li>
            <li><strong>Eğitim ve Süreç Bilgileri:</strong> Atanan eğitimler, tamamlanma durumları, video izleme süre ve ilerlemeleri, sınav/test yanıtları, puanlar ve sertifika kayıtları.</li>
            <li><strong>İşlem Güvenliği Verileri:</strong> Sisteme giriş-çıkış tarih/saat logları, IP adresi ve cihaz/tarayıcı bilgileri.</li>
          </ul>

          <h4 style={{ color: '#0f172a', fontSize: 14, margin: '18px 0 8px' }}>3. Kişisel Verilerin İşlenme Amaçları</h4>
          <ul style={{ paddingLeft: 20, margin: '8px 0' }}>
            <li>Çalışan eğitim, mesleki gelişim ve yetkinlik artırma süreçlerinin planlanması ve yürütülmesi,</li>
            <li>6331 sayılı İş Sağlığı ve Güvenliği Kanunu ve 4857 sayılı İş Kanunu başta olmak üzere yasal eğitim zorunluluklarının yerine getirilmesi ve belgelendirilmesi,</li>
            <li>Eğitim tamamlama durumlarının, sertifikasyon süreçlerinin ve performans/akademik raporların yönetilmesi,</li>
            <li>Eğitim hatırlatma ve bilgilendirme bildirimlerinin (e-posta yoluyla) iletilmesi,</li>
            <li>Bilgi güvenliği, portalın teknik sürekliliği ve işlem kayıtlarının tutulması.</li>
          </ul>

          <h4 style={{ color: '#0f172a', fontSize: 14, margin: '18px 0 8px' }}>4. Kişisel Veri Toplama Yöntemi ve Hukuki Sebepleri</h4>
          <p>
            Kişisel verileriniz; İnsan Kaynakları yönetim sistemleri üzerinden aktarılmak suretiyle ve portalı kullanımınız esnasında elektronik ortamda otomatik yöntemlerle toplanmaktadır. Söz konusu veriler, KVKK’nın 5. maddesi 2. fıkrası uyarınca:
          </p>
          <ul style={{ paddingLeft: 20, margin: '8px 0' }}>
            <li><em>"Kanunlarda açıkça öngörülmesi"</em> ve <em>"Veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması"</em> (İş ve İSG mevzuatı kapsamındaki zorunlu eğitimler),</li>
            <li><em>"Bir hakkın tesisi, kullanılması veya korunması için veri işlemenin zorunlu olması"</em> (Eğitim tamamlama ve sertifikaların resmi denetimlerde ispatı),</li>
            <li><em>"İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, veri sorumlusunun meşru menfaatleri için veri işlenmesinin zorunlu olması"</em> (Eğitim kalitesinin artırılması ve şirket içi gelişim takibi) hukuki sebeplerine dayanılarak işlenmektedir.</li>
          </ul>

          <h4 style={{ color: '#0f172a', fontSize: 14, margin: '18px 0 8px' }}>5. Kişisel Verilerin Aktarımı</h4>
          <p>
            Kişisel verileriniz; yasal raporlama ve denetim yükümlülüklerinin ifası amacıyla kanunen yetkili kamu kurum ve kuruluşları (Bakanlıklar, denetim mercileri vb.) ile mevzuata uygun olarak eğitim altyapı hizmeti sağlayan teknik iş ortaklarımız dışında üçüncü taraflarla paylaşılmamaktadır.
          </p>

          <h4 style={{ color: '#0f172a', fontSize: 14, margin: '18px 0 8px' }}>6. İlgili Kişi Olarak Haklarınız</h4>
          <p>
            KVKK’nın 11. maddesi uyarınca veri sahipleri; kişisel verilerinin işlenip işlenmediğini öğrenme, işlenmişse bilgi talep etme, işlenme amacına uygun kullanılıp kullanılmadığını öğrenme, eksik veya yanlış işlenmişse düzeltilmesini isteme ve kanuni şartlar çerçevesinde silinmesini/yok edilmesini talep etme haklarına sahiptir.
          </p>
        </div>

        {/* Footer */}
        <div style={{
          padding: "16px 24px",
          borderTop: "1px solid #e2e8f0",
          display: "flex",
          justifyContent: isMandatory ? "center" : "flex-end",
          gap: 12,
          background: "#f8fafc"
        }}>
          {isMandatory ? (
            <button
              onClick={onAcknowledge}
              style={{
                padding: "12px 32px",
                background: "#dc2626",
                color: "#ffffff",
                border: "none",
                borderRadius: 8,
                fontWeight: 600,
                fontSize: 15,
                cursor: "pointer",
                boxShadow: "0 2px 4px rgba(220, 38, 38, 0.2)",
                transition: "all 0.2s"
              }}
              onMouseEnter={e => e.currentTarget.style.background = "#b91c1c"}
              onMouseLeave={e => e.currentTarget.style.background = "#dc2626"}
            >
              Okudum, Anladım
            </button>
          ) : (
            <button
              onClick={onClose}
              style={{
                padding: "10px 24px",
                background: "#64748b",
                color: "#ffffff",
                border: "none",
                borderRadius: 8,
                fontWeight: 600,
                fontSize: 14,
                cursor: "pointer",
                transition: "all 0.2s"
              }}
              onMouseEnter={e => e.currentTarget.style.background = "#475569"}
              onMouseLeave={e => e.currentTarget.style.background = "#64748b"}
            >
              Kapat
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
